module.exports = __webpack_public_path__ + "media/images/gestor_notarial_ico-21a87da6.png";